import React from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch } from "react-redux";
import ActionMenu from "../../../components/utils/ActionMenu";
import { formatDateTime } from "../../../utils/formatDateTime";
import swal from 'sweetalert';
import { deleteInventoryForm, fetchInventoryForms, getLastInventory } from "../../../action";
import ReactTooltip from "react-tooltip";
import Content from "../../../components/layout/Content";
import { isEmpty } from 'lodash';
import moment from 'moment';

const renderBranch = (item, cities) => {
    if (!item.point) return 'Филиал не указан';
    const city = cities.find(city => city.id === item.point.city);
    const cityName = city ? city.name : 'Город не указан';
    return `${cityName}, ${item.point.street || ''} ${item.point.house || ''}`;
};

const renderAdress = (item, cities) => {
    if (!item.point) return 'Адрес не указан';
    const city = cities.find(city => city.id === item.point.city);
    const cityName = city ? city.name : 'Город не указан';
    const street = item.point.street ? item.point.street : 'Улица не указана';
    const house = item.point.house ? item.point.house : '';
    return `${cityName}, ${street} ${house}`;
};

const Item = ({ item, history, cities }) => {
    const dispatch = useDispatch();
    const branch = renderBranch(item, cities);

    const fullAddress = renderAdress(item, cities);

    const getProcessing = () => {
        if (!item.isProcessing) return false;
        const now = moment();
        const diff = now.diff(moment(item.updated_at), 'minutes');
        if (diff > 5) return false;
        return true;
    }

    const openEdit = async () => {
        if (getProcessing()) return swal({
            title: `Редактирование временно ограничено.`,
            text: 'Идет просчет данных на сервере, подождите 1-2 минуты и обновите страницу для открытия инвентаризации.',
            icon: "warning",
            dangerMode: true,
            button: "Ок",
        });

        const lastInventory = await dispatch(getLastInventory(item.point, item.id));
        if (lastInventory && lastInventory.error) {
            return swal({
                title: `Редактирование невозможно`,
                text: lastInventory.error.message || '',
                icon: "warning",
                dangerMode: true,
                button: "Ок",
            });
        };
        if (!isEmpty(lastInventory) && moment(lastInventory.date) > moment(item.date)) {
            return swal({
                title: `Редактирование невозможно`,
                text: 'Была проведена инвентаризация',
                icon: "warning",
                dangerMode: true,
                button: "Ок",
            });
        }
        history.push(`/accounting/inventory/edit/${item.id}`);
    }

    const onDeleteInventory = async () => {
        if (getProcessing()) return swal({
            title: `Удаление временно ограничено.`,
            text: 'Идет просчет данных на сервере, подождите 1-2 минуты и обновите страницу для удаления инвентаризации.',
            icon: "warning",
            dangerMode: true,
            button: "Ок",
        });

        const lastInventory = await dispatch(getLastInventory(item.point, item.id));

        if (lastInventory && lastInventory.error) {
            return swal({
                title: `Удаление невозможно`,
                text: lastInventory.error.message || '',
                icon: "warning",
                dangerMode: true,
                button: "Ок",
            });
        };

        if (!isEmpty(lastInventory) && moment(lastInventory.date) > moment(item.date)) {
            return swal({
                title: `Удаление невозможно`,
                text: 'Была проведена инвентаризация',
                icon: "warning",
                dangerMode: true,
                button: "Ок",
            });
        }
        
        const street = item.point && item.point.street ? item.point.street : 'Адрес неизвестен';
        const house = item.point && item.point.house ? item.point.house : '';

        swal({
            title: `Удаление инвентаризации`,
            text: `Вы действительно хотите удалить инвентаризацию за ${new Date(item.date).toLocaleDateString()} 
            по филиалу ${street} ${house}?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(deleteInventoryForm(item.id))
                    .then(() => {
                        swal("Успех!", "Инвентаризация была успешно удалена.", "success");
                        dispatch(fetchInventoryForms());
                    })
                    .catch(() => swal("Ошибка!", "Не удалось удалить бланк. Попробуйте еще раз.", "error"));
            }
        });
    };

    const openViewMode = () => {
        if (getProcessing()) return swal({
            title: `Просмотр временно ограничен.`,
            text: 'Идет просчет данных на сервере, подождите 1-2 минуты и обновите страницу для открытия инвентаризации.',
            icon: "warning",
            dangerMode: true,
            button: "Ок",
        });
        history.push(`/accounting/inventory/detail/${item.id}?viewMode=view`)
    }

    const actions = [
        { name: 'Просмотр',  icon: 'la la-eye', action: () => openViewMode()},
        { name: 'Введенные данные', icon: 'la la-file-text', action: () => history.push(`/accounting/inventory/detail/${item.id}?viewMode=input`)},
        { name: 'Редактировать', icon: 'la la-edit', action: () => openEdit()},
        { name: 'Удалить', icon: 'la la-trash', action: () => onDeleteInventory()},
    ];

    const handleDoubleClick = () => {
        if (getProcessing()) return swal({
            title: `Просмотр временно ограничен.`,
            text: 'Идет просчет данных на сервере, подождите 1-2 минуты и обновите страницу для открытия инвентаризации.',
            icon: "warning",
            dangerMode: true,
            button: "Ок",
        });
        history.push(`/accounting/inventory/detail/${item.id}?viewMode=view`)
    }

    const isEdit = isEmpty(item.changeLog) ? false : true;

    if (window.innerWidth > 730) {
        return (
            <Content>
                <tr key={item.id} className="kt-datatable__row" onDoubleClick={handleDoubleClick}>
                    <td width="180px" className="kt-datatable__cell">
                        <span>{formatDateTime(item.date)}</span>
                    </td>
                    <td width="auto" className="kt-datatable__cell">
                        <span>{fullAddress}</span>
                    </td>
                    <td align='center' width="180px" className="kt-datatable__cell">
                        <div>
                        <span className={`kt-badge ${getProcessing() ? "kt-badge--warning" : isEdit ? "kt-badge--danger" : "kt-badge--brand"} kt-badge--inline`}>
                            {getProcessing() ? "Идет просчет данных" : isEdit ? "Редактировалась" : "Не редактировалась"}
                        </span>
                        </div>
                    </td>
                    <td align='right' width="180px" className="kt-datatable__cell">
                        <ActionMenu actions={actions}/>
                    </td>
                </tr>
            </Content>
        );
    }

    return (
        <tr className="kt-datatable__row" onDoubleClick={handleDoubleClick}>
            <div className='mobile_div_flex column padding10px'>
                <div className='mobile_div_flex column_mobile430px'>
                    <div style={{ width: '100%' }}>
                        <span style={{ color: '#000' }}>{branch}</span>
                    </div>
                    <div style={{ width: '100%' }}>
                        <span style={{ color: '#000' }}>{formatDateTime(item.date)}</span>
                    </div>
                </div>
                <div className='mobile_div_flex column_mobile430px'>
                    <div style={{ width: '100%' }}>
                        <span className={`kt-badge ${getProcessing() ? "kt-badge--warning" : isEdit ? "kt-badge--danger" : "kt-badge--brand"} kt-badge--inline`}>
                            {getProcessing() ? "Идет просчет данных" : isEdit ? "Редактировалась" : "Не редактировалась"}
                        </span>
                    </div>
                </div>
                <div className='mobile_div_flex' style={{ justifyContent: 'flex-end', marginTop: 10 }}>
                    <div className="action-buttons">
                        <ActionMenu actions={actions} />
                        <ReactTooltip effect="solid" place="top"/>
                    </div>
                </div>
            </div>
        </tr>
    );
};

export const ItemRow = withRouter(Item);
